const state = {
  language: localStorage.getItem('language') || 'zh-CN',
  theme: '',
  themeColors: [],
  themeType: '' //simple 简约 dark 暗黑
};

const mutations = {
  // 切换语言
  changLanguage(state, language) {
    state.language = language;
    localStorage.setItem('language', language);
  },
  // 初始化语言
  initLanguage(state) {
    let language = localStorage.getItem('language') || 'zh-CN';
    localStorage.setItem('language', language);
    state.language = language;
  },
  // 初始化主题色
  initTheme(state) {
    let theme = localStorage.getItem('theme') || '#038EDC';
    localStorage.setItem('theme', theme);
    state.theme = theme;
    document.documentElement.style.setProperty('--color-primary', theme);
  },
  // 设置主题色
  setTheme(state, theme) {
    state.theme = theme;
    localStorage.setItem('theme', theme);
    document.documentElement.style.setProperty('--color-primary', theme);
  },
  // 初始化主题风格
  initThemeType(state) {
    let themeType = localStorage.getItem('themeType') || 'simple';
    localStorage.setItem('themeType', themeType);
    state.themeType = themeType;
    document.documentElement.setAttribute('theme', themeType);
  },
  // 设置主题风格
  setThemeType(state, themeType) {
    state.themeType = themeType;
    localStorage.setItem('themeType', themeType);
    document.documentElement.setAttribute('theme', themeType);
  },
  // 主题色
  setThemeColors(state, colors) {
    state.themeColors = colors
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
